import React from "react";

const Spacer = () => {
    return <span style={{flexGrow: 1}} />
}

export default Spacer;
